import { createContext, useContext, useState, useCallback } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { X } from "lucide-react";
import { QuoteForm } from "./QuoteForm";

const QuoteCtx = createContext({ openQuote: () => {} });
export const useQuote = () => useContext(QuoteCtx);

export const QuoteProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [preset, setPreset] = useState(null);
  const openQuote = useCallback((data) => {
    setPreset(data || null);
    setOpen(true);
  }, []);

  return (
    <QuoteCtx.Provider value={{ openQuote }}>
      {children}
      <AnimatePresence>
        {open && (
          <motion.div
            className="fixed inset-0 z-[100] flex items-center justify-center p-4"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            data-testid="quote-modal"
          >
            <div
              className="absolute inset-0 bg-brand-navy/70 backdrop-blur-sm"
              onClick={() => setOpen(false)}
            />
            <motion.div
              initial={{ opacity: 0, y: 40, scale: 0.96 }}
              animate={{ opacity: 1, y: 0, scale: 1 }}
              exit={{ opacity: 0, y: 40, scale: 0.96 }}
              transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
              className="relative w-full max-w-lg max-h-[90vh] overflow-y-auto rounded-2xl bg-white shadow-2xl"
              data-lenis-prevent
            >
              <button
                onClick={() => setOpen(false)}
                className="absolute right-4 top-4 z-10 rounded-full bg-slate-100 p-2 text-slate-600 hover:bg-brand-orange hover:text-white transition-colors"
                data-testid="quote-modal-close"
                aria-label="Close quote form"
              >
                <X className="h-4 w-4" />
              </button>
              <div className="p-6 sm:p-8">
                <p className="text-xs font-bold uppercase tracking-widest text-brand-orange">
                  Free Solar Consultation
                </p>
                <h3 className="mt-1 font-heading text-2xl font-bold text-brand-navy">
                  Get Your Free Solar Quotation
                </h3>
                <div className="mt-5">
                  <QuoteForm preset={preset} compact onSuccess={() => setTimeout(() => setOpen(false), 1800)} />
                </div>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </QuoteCtx.Provider>
  );
};
